module.exports = __webpack_public_path__ + "img/5.bf0bd7b0.jpg";